import { inject, Pipe, PipeTransform } from '@angular/core';

import { BaasI18n } from '@lvflanders/bar';

import { DIDO_DOCUMENTEN_CONTROL_CONSTANTS } from '../dido-documenten-control.constants';

@Pipe({
    name: 'getIconClass',
    standalone: true
})
export class GetIconClassPipe implements PipeTransform {
    readonly #i18n = inject(BaasI18n);

    transform(bestandsnaam: string): string {
        const bestandsextensie = bestandsnaam.substring(bestandsnaam.lastIndexOf('.')).toLowerCase();
        const mapping = DIDO_DOCUMENTEN_CONTROL_CONSTANTS.ALLOWED_EXTENSION_MAPPINGS.find((mapping) => mapping.extension == bestandsextensie);
        if (mapping != null) {
            return mapping.fontIcon;
        } else {
            return 'fa-file';
        }
    }
}
